import React from "react";
import LeftServiceCardSection2 from "./LeftServiceCardSection2";
// import advertise from "../../../../images/aboutimage/advertise.jpg"
import insta2 from "../../../../images/aboutimage/insta2.jpg";
import act1 from "../../../../images/aboutimage/act1.jpg";
import draw1 from "../../../../images/aboutimage/draw1.jpeg";
import act3 from "../../../../images/aboutimage/act3.jpg";

const LeftServiceSection2 = () => {
  return (
    <div className="left-blog   lg:w-[60%] w-[100%] ">
      <LeftServiceCardSection2
        date="2 feb"
        year="2021"
        title="FANCY DRESS COMPETITION"
        para=" Put on special clothes to appear particularly appealing and attractive"
        head="..."
        image={insta2}
      />
      <LeftServiceCardSection2
        date="18 March"
        year="2021"
        title="ART / CRAFT COMPETITION"
        para=" The skills of making objects for decoration and practical uses by hand."
        head="Think innovative"
        image={act1}
      />
      <LeftServiceCardSection2
        date="6 April"
        year="2022"
        title="DRAWING COMPETITION"
        para="Allow students to uncover their natural talents in sketching and illustrations."
        head="Think creative"
        image={draw1}
      />
      <LeftServiceCardSection2
        date="12 Dec"
        year="2022"
        title="RAKHI MAKING COMPETITION"
        para=" Symbolises the true love and bond between brothers and sisters"
        head="Bond of protection"
        image={act3}
      />
    </div>
  );
};

export default LeftServiceSection2;
